
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poster-maker",
      function () {
        return require("private-next-pages/poster-maker/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poster-maker"])
      });
    }
  